"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _preact = _interopRequireWildcard(require("preact"));

var _render = require("../../utils/render.utils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DoormatList = function DoormatList(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      linksRenderFunction = _ref.linksRenderFunction,
      _ref$richText = _ref.richText,
      richText = _ref$richText === void 0 ? '' : _ref$richText,
      blockIdentifier = _ref.blockIdentifier,
      blockIndex = _ref.blockIndex;
  return (0, _preact.h)("div", {
    className: "mtn-m-dmlist"
  }, (0, _preact.h)("h3", {
    className: "mtn-m-dmlist__title mtn-ts-h5"
  }, title), (0, _preact.h)("ul", {
    className: "a-list has-icon-left mtn-m-dmlist__ul"
  }, items.map(function (i, c) {
    return (0, _preact.h)("li", {
      key: i.link,
      className: "mtn-m-dmlist__li"
    }, (0, _render.renderLink)(i.link, (0, _preact.h)("span", {
      className: "mtn-m-dmlist__content"
    }, (0, _preact.h)("span", {
      className: "fa fa-angle-right"
    }), (0, _preact.h)("span", {
      className: "mtn-m-dmlist__text"
    }, i.label)), 'mtn-m-dmlist__link', linksRenderFunction, "mtn-doormat-middle-".concat(blockIdentifier, "-link-").concat(blockIndex, "-").concat(c), i.target));
  })), (0, _preact.h)("div", {
    dangerouslySetInnerHTML: {
      __html: richText
    }
  }));
};

var _default = DoormatList;
exports["default"] = _default;